import {FITH2GameConfig} from "../configs/FITH2GameConfig";
import {gsap} from "gsap";
import {BitmapText} from "pixi.js";
import {FITH2FontConfig} from "../configs/FITH2FontConfig";
import {FireInTheHole2} from "../FireInTheHole2";

export class Ways extends PIXI.Container {
    private _ways: BitmapText;

    constructor() {
        super();
        this.name = "Ways";
        this._ways = new BitmapText("486", FITH2FontConfig.WAYS);
        this._ways.anchor = new PIXI.Point(0.5, 1);
        //this._ways.letterSpacing = -12;

        const waysText:PIXI.Sprite = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("board_ways")[0]);
        waysText.anchor = new PIXI.Point(0.5, 1);
        waysText.position.set(8, 33);
        this._ways.position.set(5, 3);
        const container = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("board")[0]);
        container.anchor = new PIXI.Point(0.5);
        container.position.set(6, -47);
        this.addChild(container, waysText, this._ways);
    }

    public updateValue(value: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        if(!this._ways.visible){
            this._ways.alpha = 0;
            this._ways.visible = true;
            tl.add(gsap.to(this._ways, 0.3, {alpha:1}), 0);
        }
        tl.add(() => {
            this._ways.text = value.toString();
        }, 0);
        return tl;
    }

    public hide(): gsap.core.Timeline {
        return gsap.timeline().add(gsap.to(this._ways, 0.3, {alpha:0})).add(()=>{this._ways.visible = false;});
    }

    public reset(): void {
        this._ways.text = FITH2GameConfig.DEFAULT_WAYS.toString();
    }

    get value(): number {
        return parseInt(this._ways.text);
    }

    get textWidth(): number {
        return this._ways.width;
    }

    get textHeight(): number {
        return this._ways.height;
    }
}